export const filterFilms = (filmProducts, selectedProcessesArr, selectedSubstrateStr) => {
  let filtered = [...filmProducts];

  if (selectedProcessesArr && selectedProcessesArr.length > 0) {
    if (selectedProcessesArr.includes('Refrigerated')) {
      const processesToCheck = selectedProcessesArr.filter((process) => process !== 'Refrigerated');
      if (processesToCheck.length > 0) {
        const processToKeyMap = {
          Microwaved: 'microwavable',
          Oven: 'ovenable',
          Frozen: 'freezable'
        };
        filtered = filtered.filter((film) =>
          processesToCheck.every((processName) => {
            const filmPropertyKey = processToKeyMap[processName];
            return filmPropertyKey ? film[filmPropertyKey] === true : true;
          })
        );
      }
    } else {
      const processToKeyMap = {
        Microwaved: 'microwavable',
        Oven: 'ovenable',
        Frozen: 'freezable'
      };
      filtered = filtered.filter((film) =>
        selectedProcessesArr.every((processName) => {
          const filmPropertyKey = processToKeyMap[processName];
          return filmPropertyKey ? film[filmPropertyKey] === true : true;
        })
      );
    }
  }

  if (selectedSubstrateStr && selectedSubstrateStr !== "I don't know") {
    const substrateToKeyMap = {
      Polypropylene: 'pp',
      PET: 'apetPet',
      CPET: 'cpet'
    };
    const filmPropertyKey = substrateToKeyMap[selectedSubstrateStr];
    if (filmPropertyKey) {
      filtered = filtered.filter((film) => film[filmPropertyKey] === true);
    }
  }

  return filtered;
};
